import type { FC } from 'react';
import { useState } from 'react';
import type { Theme } from '@material-ui/core/styles';
import {
  makeStyles, createStyles, lighten,
} from '@material-ui/core/styles';
import {
  Box,
  Collapse,
  Grid, Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import clsx from 'clsx';
import type { NavLink } from './NavigationTypes';

interface NavigationNestedLinkProps {
  linkProp: NavLink,
  linkOnClickProp: () => void,
}

const useStyles = makeStyles((theme: Theme) => createStyles({
  linkHeader: {
    color: lighten(theme.palette.primary.main, 0.25),
    letterSpacing: '2px',
  },
  link: {
    color: theme.palette.common.white,
    marginBottom: '0.75rem',
  },
  reactRouterLink: {
    textDecoration: 'none',
  },
  dropdown: {
    transition: theme.transitions.create(['transform'], {
      duration: theme.transitions.duration.standard,
    }),
  },
  dropdownOpen: {
    color: theme.palette.common.white,
    transform: 'rotate(180deg)',
  },
  dropdownClosed: {
    color: theme.palette.common.white,
    transform: 'rotate(90deg)',
  },
}));

const NavigationNestedLink: FC<NavigationNestedLinkProps> = ({
  linkProp,
  linkOnClickProp,
}) => {
  const classes = useStyles();
  const [dropDownState, setDropDownState] = useState(false);

  if (!linkProp.nestedLinks) {
    return null;
  }

  return (
    <>
      <Grid item xs={11} key={linkProp.displayText}>
        <Typography className={classes.link} onClick={() => setDropDownState(!dropDownState)}>{linkProp.displayText}</Typography>
        <Collapse in={dropDownState}>
          {
                linkProp.nestedLinks.map((linkItem) => (
                  <Box ml={2} my={1}>
                    <Link
                      id={`${linkItem.displayText.replace(' ', '-').toLowerCase()}`}
                      to={linkItem.link}
                      className={classes.reactRouterLink}
                      onClick={(e) => {
                        if (e.currentTarget instanceof HTMLElement) {
                          e.currentTarget.blur();
                          linkOnClickProp();
                        }
                      }}
                    >
                      <Typography className={classes.link}>{linkItem.displayText}</Typography>
                    </Link>
                  </Box>
                ))
                }
        </Collapse>
      </Grid>
      <Grid item xs={1}>
        <ArrowRightIcon onClick={() => setDropDownState(!dropDownState)} className={clsx(classes.dropdown, dropDownState ? classes.dropdownClosed : classes.dropdownOpen)} />
      </Grid>
    </>
  );
};
export default NavigationNestedLink;
